import { Dispatch, SetStateAction, useState, useEffect, useCallback } from 'react';
import s from './index.module.scss';
import { useTranslation } from 'react-i18next';
import Img from '@/component/Img';
import OneLinkImg from '@/component/wing/OneLinkImg';
import cx from 'classnames';
import { generateSignature } from '@/util/signature';
import { Stage } from '../const';
import { useToast } from '@/stores/ToastContext';


export default function Phone(props: {
    setStage: Dispatch<SetStateAction<number>>,
    setCountryCode: Dispatch<SetStateAction<string>>,
    setMobileNumber: Dispatch<SetStateAction<number>>,
    countryCode: string,
    mobileNumber: string,
}) {
  const { t } = useTranslation();
  const { setStage } = props;
  const { countryCode, setCountryCode, mobileNumber, setMobileNumber } = props;
  const [active, setActive] = useState(false);
  const showToast = useToast();

  useEffect(() => {
    setActive(mobileNumber?.length > 0 && countryCode?.length > 0);
  }, [mobileNumber, countryCode]);

  const handleChange = (e) => {
    setMobileNumber(e.target.value);
  };
  const handlePrefixChange = (e) => {
    setCountryCode(e.target.value || undefined);
  };

  const handleCommit = useCallback(async () => {
    const token = await (window as any).grecaptcha.enterprise.execute(process.env.RECAPTCHA_SITE_KEY, { action: 'submit' });
    const res = await fetch(`${window.location.protocol}//${window.location.host}/api/confirmation-code?token=${token}`, {
      method: 'POST',
      body: JSON.stringify({
        countryCode: Number(countryCode),
        mobileNumber,
        grantType: 'phone',
        signature: generateSignature('phone', '', String(countryCode), mobileNumber),
      }),
    });
    if (res.ok) { // 检查响应是否成功
      const responseBody = await res.json(); // 解析响应体为 JSON
      if (responseBody.meta.code === 200) {
        return setStage(Stage.Varify);
      } else if (responseBody.meta.code === 40010) {
        showToast(t('DUET_H5_ACCOUNT_MANAGE_PHONE_ERROR_TOAST'));
      } else if (responseBody.meta.code === 40013) {
        showToast(t('DUET_H5_ACCOUNT_MANAGE_REQUEST_MAX_ERROR_TOAST'));
      } else {
        showToast(t('DUET_H5_ACCOUNT_MANAGE_PHONE_ERROR_TOAST'));
      }
    } else {
      showToast('DUET_H5_ACCOUNT_MANAGE_ERROR_PAGE_TITLE');
    }
  }, [mobileNumber, countryCode]);

  return (

    <>
      <div className={s.icon} />
      <div className={s.title}>{t('DUET_WEB_SIGNIN_NUMBER_TITLE')}</div>
      <div className={s.inputWrapper}>
        <div className={s.countryCodeWrapper}>
          <div>{t('DUET_WEB_SIGNIN_NUMBER_COUNTRYCODE')}</div>
          <input
            type="number"
            value={countryCode}
            onChange={handlePrefixChange}
            className={cx(s.prefixInput, s.input)}
          />
        </div>
        <div className={s.mobileWrapper}>
          <div>{t('DUET_WEB_SIGNIN_NUMBER_MOBILE')}</div>
          <input
            type="tel"
            value={mobileNumber}
            onChange={handleChange}
            className={s.input}
            placeholder={t('DUET_H5_ACCOUNT_MANAGE_PHONE_LOGIN_NUMBER_PAGE_PLACEHOLDER')}
          />
        </div>
      </div>
      <div className={s.bottomText}>{t('DUET_WEB_SIGNIN_NUMBER_CONTENT')}</div>
      <div className={cx(s.button, { [s.active]: active })} onClick={handleCommit}>{t('DUET_WEB_SIGNIN_NUMBER_BUTTON')}</div>
    </>

  );
}
